module.exports = {"twitter:card":"summary_large_image","twitter:site":"@auth0","twitter:creator":"@auth0","twitter:title":"Auth0 - Identity infrastructure, for developers","twitter:description":"A universal identity platform for customers, employees and partners","twitter:image":[{"src":"https://cdn.auth0.com/website/assets/modules/twittercard/1x-new-383f8d95d1.png","width":"1024","height":"512"}]}


//////////////////
// WEBPACK FOOTER
// ./src/modules/twittercard/defaults.json
// module id = 1581
// module chunks = 0